import{reduce as r}from"./reduce.js";function n(r,n,t){return 0===t?[n]:(r.push(n),r)}function t(){return r(n,[])}export{t as toArray};
